import Typography from "@portal/components/atoms/v2/typography";
import { useState } from "react";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { ChevronCircleButton } from "@portal/components/atoms/buttons/chevronCircle/ChevronCircleButton";
import { SelectionBoxComponent } from "../../../components/selectionBox/SelectionBoxComponent";
import { useRobot } from "@portal/app/context/robotProvider";
import { GetOption } from "../../../sustainability/common/helpers/getOption";
import PortalPageBox from "@portal/components/atoms/portalPageBox";
import { ISustainabilityProps } from "../../../sustainability/common/types";

export const EUInfo = ({ isDefaultLanguage }: ISustainabilityProps) => {
  const { riskLevelRequest, setSustainabilityEu } = useRobot();
  const [isExpanded, setIsExpanded] = useState(false);
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const options = [texts.PAGE_7_OPTIONS_4_A, texts.PAGE_7_OPTIONS_4_B];
  const OnSelectionClick = (selectedOption: number) => {
    if (selectedOption !== null) {
      setSustainabilityEu(selectedOption === 0);
    }
  };
  return (
    <div className="flex flex-col sm:flex-row sm:space-x-3">
      <PortalPageBox className="flex flex-col my-3 sm:w-[60%]">
        <Typography variant="Lead">{texts.PAGE_7_INFO_TEXT_4_HEADER}</Typography>
        <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_4_A}</Typography>
        <div className="ml-2 my-2">
          <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_4_B}</Typography>
          <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_4_C}</Typography>
          <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_4_D}</Typography>
          <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_4_E}</Typography>
          <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_4_F}</Typography>
          <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_4_G}</Typography>
        </div>
        <div>
          <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_4_H}</Typography>
        </div>
        <div className="flex py-2 justify-center">
          <ChevronCircleButton isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
        </div>
        {isExpanded && <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_4_I}</Typography>}
      </PortalPageBox>
      <div className="flex sm:w-[40%] w-full">
        <SelectionBoxComponent
          options={options}
          selectedOption={GetOption(riskLevelRequest.sustainabilityEu) ?? -1}
          onSelectionClick={OnSelectionClick}
        />
      </div>
    </div>
  );
};
